import styled from 'styled-components';

export const ContainerTextos = styled.div`
  display: inline;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[1]}px;
`;
